import { render, staticRenderFns } from "./BtnControl.vue?vue&type=template&id=6ead0e2e&scoped=true"
import script from "./BtnControl.vue?vue&type=script&lang=js"
export * from "./BtnControl.vue?vue&type=script&lang=js"
import style0 from "./BtnControl.vue?vue&type=style&index=0&id=6ead0e2e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ead0e2e",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip});
